import { render, staticRenderFns } from "./WeightRow.vue?vue&type=template&id=39733eb4"
import script from "./WeightRow.vue?vue&type=script&lang=js"
export * from "./WeightRow.vue?vue&type=script&lang=js"
import style0 from "./WeightRow.vue?vue&type=style&index=0&id=39733eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports